module.exports = __webpack_public_path__ + "img/pdf_qr_locator.ded161f6.png";